import axios, { AxiosResponse } from 'axios';
import { authToken } from 'src/env';
import { environment } from 'src/environments/environment';

const apiClient = axios.create({
  baseURL: environment.REACT_APP_PLAN_BASE_URL,
  headers: {
    Authorization: `Bearer ${authToken}`,
  },
});

const apiEndUserClient = axios.create({
  baseURL: environment.REACT_APP_ENDUSER_BASE_URL,
  headers: {
    Authorization: `Bearer ${authToken}`,
  },
});

const getPlanSupportedDestinations = async () => {
  try {
    const response = await apiClient.get('/api/coverage/supported/country');
    return response;
  } catch (error) {
    console.error('API Error ', error);
    return error;
  }
};

const redeemOffer = async (id: any) => {
  try {
    const payload = {
      id: id,
    };

    const response = await apiEndUserClient.post(
      '/api/guest/redemption/check/eligibility',
      payload
    );
    return response;
  } catch (error) {
    console.error('API Error ', error);
    throw error;
  }
};

const fetchOfferDetailByLast4 = async (last4: string) => {
  try {
    const payload = {
      last4: last4,
    };

    const response = await apiEndUserClient.post(
      '/api/guest/redemption/check/eligibility',
      payload
    );
    return response;
  } catch (error) {
    console.error('API Error ', error);
    return error;
  }
};

export {
  getPlanSupportedDestinations as getPlanSupportedCountries,
  redeemOffer,
  fetchOfferDetailByLast4,
};
